import { useNavigate } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { WarningIcon } from 'Asset/icon';
import { TextBold, TextRegular } from 'UiKit/typography';
import ButtonSolid from 'UiKit/button/buttonSolid';

import { useScheduleState } from 'View/schedule/state';

import styles from './styles.module.css';

const ScheduleAlert = ({ scheduleData }) => {
  const { t } = useTranslation('schedule');
  const navigate = useNavigate();
  const { filterState } = useScheduleState();

  const numScheduleWarnings = scheduleData?.noActiveHostScheduleCount;

  return (
    <Box className={styles['schedule-alert__container']}>
      <Flex gap="12px" alignItems="flex-start">
        <WarningIcon width="22px" height="22px" color="var(--color-error50)" />
        <Flex flexDirection="column" gap="8px">
          <TextBold fontSize="var(--font-body1)" color="var(--color-error80)">
            {t('noHostAlertTitle', { count: numScheduleWarnings })}
          </TextBold>
          <TextRegular color="var(--color-error80)">{t('noHostAlertDescription')}</TextRegular>
          <ButtonSolid
            width="fit-content"
            background="var(--color-error50)"
            onClick={() => {
              sessionStorage.setItem('scheduleFilterState', JSON.stringify(filterState));
              navigate(`/schedule/change-host`);
            }}
          >
            {t('manageSchedule')}
          </ButtonSolid>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ScheduleAlert;
